<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card>
                <template v-slot:header>
                    <h5>Cap Emas</h5>
                </template>
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group label="Filter" label-for="filterInput" class="form-inline form-group-wrapper mb-3">
                        <div class="d-flex search-input-wrapper">
                            <b-form-input @keyup.enter="onFilter" class="mx-2" v-model="filter.filterName" name="filterIsActive" type="search"
                                placeholder="Nama"></b-form-input>

                            <b-form-select class="mx-2" id="filterIsActive" v-model="filter.filterIsActive" name="filterIsActive"
                                value-field="value" text-field="text">
                                <b-select-option selected disabled :value="null">-- Status -- </b-select-option>
                                <b-select-option :value="true">Aktif</b-select-option>
                                <b-select-option :value="false">Non-Aktif</b-select-option>
                            </b-form-select>
                    
                            <b-form-select class="mx-2" id="filterIsPopular" v-model="filter.filterIsPopular" name="filterIsPopular"
                                value-field="value" text-field="text">
                                <b-select-option selected disabled :value="null">-- Status -- </b-select-option>
                                <b-select-option :value="true">Terkenal</b-select-option>
                                <b-select-option :value="false">Non-Terkenal</b-select-option>
                            </b-form-select>

                            <b-button class="mx-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn"
                                @click="onFilter">
                                <i class="fa fa-search"></i>
                            </b-button>

                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy"
                                @click="onReset">Reset</b-button>
                        </div>
                    </b-form-group>
                    <div>
                        <b-button class="mb-3" variant="pgiBtn" name="promoAddBtn" @click="onInput">
                            <i class="fa fa-plus mr-2"></i>
                            Input Cap
                        </b-button>
                    </div>
                </div>
                <b-table bordered hover show-empty :busy="isBusy" :items="capEmas" :fields="fieldsSpek"
                    :no-local-sorting="false" @sort-changed="sortingChanged" responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data.
                    </template>

                    <template v-slot:cell(merk)="row">
                        {{ row.item.merk.name }}
                    </template>
                    <template v-slot:cell(isActive)="row">
                        <b-badge variant="success" v-if="row.item.isActive == true">AKTIF</b-badge>
                        <b-badge variant="danger" v-else>NON-AKTIF</b-badge>
                    </template>
                    <template v-slot:cell(isPopular)="row">
                        <b-badge variant="success" v-if="row.item.isPopular == true">TERKENAL</b-badge>
                        <b-badge variant="danger" v-else>NON-TERKENAL</b-badge>
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Edit"
                            @click="onEdit(row.item)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>
                        <b-button @click="confSwitchStatus(row.item.id)" size="sm"
                            :variant="row.item.isActive ? 'danger' : 'success'" v-b-tooltip.hover
                            :title="row.item.isActive ? 'Non-Aktifkan' : 'Aktifkan'" class="mr-3">
                            <i class="fa fa-power-off"></i>
                        </b-button>
                        <b-button size="sm" variant="pgiBtn" name="bayarBtn" v-b-tooltip.hover title="Upload Foto"
                            @click="uploadFoto(row.item.id)">
                            <i class="fa fa-picture-o" aria-hidden="true"></i>
                        </b-button>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="paginate.show" id="showItems" :options="options" @change="onLimitChange">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ paginate.totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0" v-model="paginate.currentPage" :total-rows="paginate.rows"
                        :per-page="paginate.perPage" aria-controls="my-table" @input="onPageChange"></b-pagination>
                </div>

                <b-modal id="modal-input" title="Input Cap" no-close-on-esc no-close-on-backdrop>
                    <b-form id="inputCap" @submit.prevent="confInput()">

                        <b-form-group>
                            <label for="name">Nama</label>
                            <b-input-group>
                                <b-form-input class="w-full" v-model="input.name" name="name"></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group label="Adjustment">
                            <b-input-group append="Gram">
                                <b-form-input v-model="input.adjustment" name="adjustment" min="0" step="0.01"
                                    @blur="roundPersen()" type="number" required></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group label="Jenis Emas">
                            <multiselect name="jenisEmas" v-model="input.jenisEmas" :disabled="optJenisEmas.length == 0"
                                :options="optJenisEmas" :internal-search="true" :allow-empty="false" deselect-label=""
                                select-label="" label="name" track-by="name" placeholder="-- Please select an option --" />
                        </b-form-group>

                        <b-form-group label="Merk Emas">
                            <multiselect name="merkEmas" v-model="input.merkEmas" :disabled="optMerkEmas.length == 0"
                                :options="optMerkEmas" :internal-search="true" :allow-empty="false" deselect-label=""
                                select-label="" label="name" track-by="name" placeholder="-- Please select an option --" />
                        </b-form-group>

                        <b-form-group label="Terkenal">
                            <b-form-select id="isPopular" v-model="input.isPopular" name="isPopular"
                                value-field="value" text-field="text">
                                <b-select-option selected disabled :value="null">-- Terkenal -- </b-select-option>
                                <b-select-option :value="true">Terkenal</b-select-option>
                                <b-select-option :value="false">Non-Terkenal</b-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-form>
                    <template v-slot:modal-footer="{ cancel }">
                        <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                            Cancel
                        </b-button>
                        <b-button variant="pgiBtn" type="submit" form="inputCap">
                            Submit
                        </b-button>
                    </template>
                </b-modal>

                <b-modal id="modal-edit" title="Edit Cap" no-close-on-esc no-close-on-backdrop>
                    <b-form id="editCap" @submit.prevent="confEdit()">

                        <b-form-group>
                            <label for="name">Nama</label>
                            <b-input-group>
                                <b-form-input class="w-full" v-model="input.name" name="name"></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group label="Adjustment">
                            <b-input-group append="Gram">
                                <b-form-input v-model="input.adjustment" name="adjustment" min="0" step="0.01"
                                    @blur="roundPersen()" type="number" required></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group label="Jenis Emas">
                            <multiselect name="jenisEmas" v-model="input.jenisEmas" :disabled="optJenisEmas.length == 0"
                                :options="optJenisEmas" :internal-search="true" :allow-empty="false" deselect-label=""
                                select-label="" value="id" label="name" track-by="name"
                                placeholder="-- Please select an option --" />
                        </b-form-group>

                        <b-form-group label="Merk Emas">
                            <multiselect name="merkEmas" v-model="input.merkEmas" :disabled="optMerkEmas.length == 0"
                                :options="optMerkEmas" :internal-search="true" :allow-empty="false" deselect-label=""
                                select-label="" label="name" track-by="name" placeholder="-- Please select an option --" />
                        </b-form-group>

                        <b-form-group label="Terkenal">
                            <b-form-select id="isPopular" v-model="input.isPopular" name="isPopular"
                                value-field="value" text-field="text">
                                <b-select-option selected disabled :value="null">-- Terkenal -- </b-select-option>
                                <b-select-option :value="true">Terkenal</b-select-option>
                                <b-select-option :value="false">Non-Terkenal</b-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-form>
                    <template v-slot:modal-footer="{ cancel }">
                        <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                            Cancel
                        </b-button>
                        <b-button variant="pgiBtn" type="submit" form="editCap">
                            Submit
                        </b-button>

                    </template>
                </b-modal>

                <b-modal id="modal-upload-foto" title="Upload Foto" no-close-on-backdrop>
                    <div v-if="loadDetail">
                        <div class="text-center my-2">
                            Mengambil data, mohon menunggu...
                        </div>
                    </div>
                    <div v-else>
                        <DataFoto :id="activeItem" :dataFotoPendukung="dataFotoPendukung" @fetchFoto="fetchFoto" />
                    </div>

                    <template v-slot:modal-footer="{ cancel }">
                        <b-button variant="pgiBtn" name="closePreviewBtn" @click="cancel()">
                            Tutup
                        </b-button>
                    </template>
                </b-modal>

                <ModalConfirm id="modal-conf-input" title="Confirm Input Cap Emas"
                    desc="Apakah anda yakin untuk menambah Cap ini?" :isSubmitting="isSubmitting" @submit="onSubmit" />

                <ModalConfirm id="modal-conf-edit" title="Confirm Edit Cap Emas"
                    desc="Apakah anda yakin untuk mengubah Cap ini?" :isSubmitting="isSubmitting" @submit="onUpdate" />

                <ModalConfirm id="conf-switch-status" title="Confirm Ubah Status" :isSubmitting="isSubmitting"
                    desc="Apakah kamu yakin untuk mengubah status Cap ini?" @submit="onSwitchStatus()" />

            </b-card>
        </div>
    </div>
</template>

<script>
import DataFoto from './DataFoto.vue'
export default {
    name: 'master-cap-emas',
    components: { DataFoto },
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            activeItem: null,
            loadDetail: false,

            capEmas: [],
            optJenisEmas: [],
            optMerkEmas: [],
            dataFotoPendukung: {
                fotoPendukung: null,
                fotoPendukungBase64: null,
                activeFotoPendukungBase64: null,
            },
            filter: {
                show: 10,
                filterName: null,
                filterIsActive: null,
                filterIsPopular: null
            },

            input: {
                name: null,
                adjustment: null,
                jenisEmas: null,
                merkEmas: null,
                isPopular: null
            },
            fieldsSpek: [
                { key: "name", label: "Nama" },
                { key: "merk", label: "Merk" },
                { key: "adjustment", label: "Adjustment" },
                { key: "isActive", label: "Status" },
                { key: "isPopular", label: "Terkenal" },
                { key: "action", label: "Aksi" }
            ],

            paginate: {
                show: 10,
                currentPage: 1,
                perPage: 10,
                rows: null,
                totalViewText: "",
                page: '',
                size: '',
                query: "",
            },

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],
        }
    },

    methods: {
        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0
            this.paginate.page = 0
            this.paginate.size = this.paginate.show

            this.paginate.query = this.$helper.makeQuery(this.paginate.page, this.paginate.size)


            let getCapEmas = this.$axios.get("cap-emas/" + this.paginate.query).then(response => {
                this.capEmas = response.data.data
                this.updateTotalItem(response.data.total)
            })

            let getJenisEmas = this.$axios.get(`barang-jenis/emas`).then(response => {
                this.optJenisEmas = response.data
            })

            Promise.all([getCapEmas, getJenisEmas]).then(() => {
                this.initStatus = 1
                this.toggleBusy()

            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })

        },

        fetch() {
            this.toggleBusy()
            this.capEmas = []
            if (this.$helper.isNotNullAndNotEmpty(this.filter.filterName)) this.paginate.query = this.paginate.query + "&filterName=" + this.filter.filterName
            if (this.$helper.isNotNullAndNotEmpty(this.filter.filterIsPopular)) this.paginate.query = this.paginate.query + "&filterIsPopular=" + this.filter.filterIsPopular
            if (this.filter.filterIsActive != null) this.paginate.query = this.paginate.query + "&filterIsActive=" + this.filter.filterIsActive  + "&filterIsPopular=" + this.filter.filterIsPopular

            this.$axios.get("cap-emas/" + this.paginate.query).then(response => {
                this.capEmas = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)

            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()

                })
        },

        onInput() {
            this.input = {
                name: null,
                adjustment: null,
                jenisEmas: null,
                merkEmas: null,
                isPopular: false
            },
                this.$bvModal.show('modal-input')
        },

        async onEdit(item) {
            this.activeItem = item.id
            this.input.name = item.name
            this.input.adjustment = item.adjustment
            this.input.jenisEmas = await item.jenis
            this.input.merkEmas = await item.merk
            this.$bvModal.show('modal-edit')
        },

        confInput() {
            if (this.$helper.isNullOrEmpty(this.input.name)) {
                return this.$helper.toastErr(this, "Mohon isi Nama.")
            }
            if (this.$helper.isNullOrEmpty(this.input.adjustment)) {
                return this.$helper.toastErr(this, "Mohon isi Adjustment.")
            }
            if (this.$helper.isNullOrEmpty(this.input.jenisEmas)) {
                return this.$helper.toastErr(this, "Mohon isi Jenis Emas.")
            }
            if (this.$helper.isNullOrEmpty(this.input.merkEmas)) {
                return this.$helper.toastErr(this, "Mohon isi Merk Emas.")
            }

            this.$bvModal.show('modal-conf-input')
        },

        confEdit() {
            if (this.$helper.isNullOrEmpty(this.input.name)) {
                return this.$helper.toastErr(this, "Mohon isi Nama.")
            }
            if (this.$helper.isNullOrEmpty(this.input.adjustment)) {
                return this.$helper.toastErr(this, "Mohon isi Adjustment.")
            }
            if (this.$helper.isNullOrEmpty(this.input.jenisEmas)) {
                return this.$helper.toastErr(this, "Mohon isi Jenis Emas.")
            }
            if (this.$helper.isNullOrEmpty(this.input.merkEmas)) {
                return this.$helper.toastErr(this, "Mohon isi Merk Emas.")
            }

            this.$bvModal.show('modal-conf-edit')
        },

        onSubmit() {
            this.isSubmitting = true
            var json = {
                name : this.input.name,
                adjustment : this.input.adjustment,
                merkId : this.input.merkEmas.id,
                isPopular: this.input.isPopular
            }
            this.$axios.post("cap-emas/",json).then(() => {
                this.isSubmitting = false
                this.$helper.toastSucc(this, "Data Berhasil Diinput.")
                this.$bvModal.hide('modal-conf-input')
                this.$bvModal.hide('modal-input')
                this.fetch()
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })

        },

        onUpdate() {
            this.isSubmitting = true
            var json = {
                id: this.activeItem,
                name : this.input.name,
                adjustment : this.input.adjustment,
                merkId : this.input.merkEmas.id,
                isPopular : this.input.isPopular
            }
            this.$axios.post("cap-emas/update",json).then(() => {
                this.isSubmitting = false
                this.$helper.toastSucc(this, "Data Berhasil Diubah.")
                this.$bvModal.hide('modal-conf-edit')
                this.$bvModal.hide('modal-edit')
                this.fetch()
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },

        confSwitchStatus(id) {
            this.activeItem = id
            this.$bvModal.show('conf-switch-status')
        },

        onSwitchStatus() {
            this.isSubmitting = true

            this.$axios.post(`cap-emas/switch-active?id=${this.activeItem}`).then(() => {
                this.$helper.toastSucc(this, "status berhasil diubah!")
                this.$bvModal.hide("conf-switch-status")
                this.fetch()
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },

        uploadFoto(id) {
            this.activeItem = id
            this.$bvModal.show('modal-upload-foto')
            this.fetchFoto()
        },

        roundPersen() {
            if (this.input.adjustment > 999.99) {
                this.input.adjustment = 999.99
            }
            if (this.input.adjustment < -999.99) {
                this.input.adjustment = -999.99
            }
            this.input.adjustment = Number(this.input.adjustment).toFixed(2);
        },

        fetchFoto() {
            this.loadDetail = true
            this.$axios.get(`cap-emas/photos?id=${this.activeItem}`)
                .then(response => {
                    this.dataFotoPendukung.activeFotoPendukungBase64 = response.data
                    this.loadDetail = false
                }).catch(error => {
                    // Tindakan jika terjadi kesalahan
                    console.log(error);
                    this.$bvModal.show('modal-upload-foto')
                    this.$helper.toastErr(this, error.response.data.reason)
                    this.loadDetail = false
                });

        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        sortingChanged(ctx) {
            if (ctx.sortBy != "") {
                this.filter.sortBy = ctx.sortBy
                this.filter.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onFilter() {
            this.paginate.page = 0
            this.paginate.currentPage = 1
            this.paginate.query = this.$helper.makeQuery(0, this.paginate.size)
            this.fetch()

        },

        updateTotalItem(total) {
            let limit = null
            let prevLimit = null
            this.paginate.perPage = this.paginate.size
            this.paginate.rows = total
            prevLimit = this.paginate.page * this.paginate.size + 1
            limit = this.paginate.page * this.paginate.size + this.paginate.size
            if (limit > this.paginate.rows) limit = this.paginate.rows
            this.paginate.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.paginate.rows + " entri"
        },

        onLimitChange() {
            this.paginate.size = this.paginate.show
            this.paginate.perPage = this.paginate.show
            this.paginate.currentPage = 1
            this.paginate.page = 0
            this.paginate.query = this.$helper.makeQuery(0, this.paginate.size)
            this.fetch()
        },

        onPageChange() {
            if (this.isBusy == false) {
                this.paginate.page = this.paginate.currentPage - 1
                this.paginate.query = this.$helper.makeQuery(this.paginate.page, this.paginate.size)
                this.fetch()
            }
        },

        onReset() {
            this.filter.filterName = null
            this.filter.filterIsActive = null
            this.filter.filterIsPopular = null

            this.currentPage = 1
            this.page = 0
            this.paginate.query = this.$helper.makeQuery(0, 10)
            this.fetch()
        },
    },
    created() {
        this.init()
    },

    watch: {
        "input.jenisEmas": function (newVal) {
            this.optMerkEmas = []
            this.input.merkEmas = null
            if (newVal == null) { return }

            if (newVal.id != null) {
                this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                    this.optMerkEmas = response.data
                    if (this.optMerkEmas.length === 1 && this.input.merkEmas == null) {
                        this.input.merkEmas = this.optMerkEmas[0]
                    }
                })
            }
        },

    }
}
</script>